export const BASE_URL = process.env.REACT_APP_BASE_URL

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
